// extracted by mini-css-extract-plugin
export default {"root":"_3lhZM","expanded":"_1V0wo"};